var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivitAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.336,
    height: 25.791,
    viewBox: "0 0 22.336 25.791",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Divit_Symbol",
    "data-name": "Divit Symbol",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M304.721,218.333l-.382,4.3.382,4.3,3.723-2.149,3.723-2.149-3.341-2.531Z",
    transform: "translate(-297.275 -201.139)",
    fill: "#f93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M329.092,204.262l-.382,4.3.382,4.3,3.723-2.149,3.723-2.149L333.2,206.03Z",
    transform: "translate(-314.201 -191.367)",
    fill: "#c00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M329.092,184.718l-.382-4.3.382-4.3,3.723,2.149,3.723,2.149L333.2,182.95Z",
    transform: "translate(-314.201 -171.822)",
    fill: "#609",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M329.96,194.49l3.723-2.149,3.723-2.149v8.6l-3.723-2.149Z",
    transform: "translate(-315.069 -181.595)",
    fill: "#909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M304.721,170.647l-.382-4.3.382-4.3,3.723,2.149,3.723,2.149-3.341,2.531Z",
    transform: "translate(-297.275 -162.05)",
    fill: "#03c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M305.589,180.419l3.723-2.149,3.723-2.149v8.6l-3.723-2.149Z",
    transform: "translate(-298.143 -171.822)",
    fill: "#009",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M281.217,172.8h7.445V162.05L284.94,164.2l-3.723,2.149",
    transform: "translate(-281.217 -162.05)",
    fill: "#09f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M281.217,211.283h7.445v10.751l-3.723-2.149-3.723-2.149",
    transform: "translate(-281.217 -196.242)",
    fill: "#fc3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M305.589,208.561l3.723,2.149,3.723,2.149v-8.6l-3.723,2.149Z",
    transform: "translate(-298.143 -191.367)",
    fill: "#f63",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivitAlt);
export default __webpack_public_path__ + "static/media/divit-alt.e3b0381a805090269de0d020dd4d1d58.svg";
export { ForwardRef as ReactComponent };